module.exports = __webpack_public_path__ + "img/c00_buildingtechroad_Normal_ua.9ef6206c.webp";